<div *ngIf="isLoading" class="loading-overlay">
  <div class="text-center spinner-wrapper">
    <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
</div>
<div>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <div class="card mb-30">
        <!-- <div class="sku-title-header">
          <h2>OTC SKU Ranking</h2>
        </div> -->

        <sales-date-filter-tag
          pageName="SkuRanking"
          (onDateTypeSaveItemsChange)="onDateTypeSaveItemsChange($event)"
          ></sales-date-filter-tag>
      </div>
    </div>
  </div>

  <app-sku-ranking-vs-ly-ranking *ngIf="readyToLoadData" [selectedDateType]="selectedDateType" [selectedSalesDate]="selectedSalesDate"></app-sku-ranking-vs-ly-ranking>
</div>
